export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
